module.exports = __webpack_public_path__ + "assets/img/gift-1-d-ca256a47.png";